import { useEffect, useState } from "react";
import { AutocompleteInput, useGetList } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const ProductCodeFilterInput = ({ source, ...props }) => {
  const { control } = useFormContext();
  const selectedCode = useWatch({ control, name: source });
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    // Keep the server query aligned with the actual form value. This is
    // important when the report is restored from the URL or reset externally.
    setSearchText(selectedCode ? String(selectedCode) : "");
  }, [selectedCode]);

  const { data = [], isLoading } = useGetList(
    "products/dropdown",
    {
      pagination: { page: 1, perPage: 25 },
      sort: { field: "products.code", order: "ASC" },
      filter: {
        detail_type: "all",
        ...(searchText ? { code: searchText } : {}),
      },
    },
    { keepPreviousData: true }
  );

  return (
    <AutocompleteInput
      {...props}
      source={source}
      choices={data}
      optionValue="code"
      optionText="code"
      isLoading={isLoading}
      onInputChange={(_event, value, reason) => {
        if (reason === "input") setSearchText(value || "");
        if (reason === "clear") setSearchText("");
      }}
      filterOptions={(options) => options}
      resettable
      fullWidth
    />
  );
};

export default ProductCodeFilterInput;
